import React, { Component } from 'react';
import CommonFunctions from './CommonFunctions';
import PhrasesList from './PhrasesList';

export default class VoiceTrainerMainPanel extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showSelectMenu: false,
			filterPhrases:
				(CommonFunctions.getSetting('filterPhrases', '1') === '1')
		};
	}

	render() {
		return (
			<div className="box">
				<div className="row header mx-auto">

					<button
						onClick={() => { this.props.app.setState({ mode: 'learn' }); }}>
						Learn
					</button>

					<button
						style={{ marginLeft: 5 }}
						onClick={() => {
								if (this.phrasesList.state.selectedPhrases.length
										< 6) {
									alert('Not enough phrases was selected for the train.');
									return;
								}
								this.props.app.setState({ mode: 'train' });
							}}>
						Train
					</button>
	{/*
					<button
							title="Simple test"
							style={{ marginLeft: 5 }}
							onClick={() => {
								if (this.props.app.getUnknownWords().length)
								props.app.setState({ mode: 'test' });
								else this.props.app.showMessage('No selected words.');
							}}>
						Test
					</button>
	*/}
					<div style={{ display: 'inline', marginLeft: 5 }} >
						{ this.state.showSelectMenu && (
							<div id="select-menu">
								<a onClick={() => {
										this.phrasesList.selectAll();
										this.setState({ showSelectMenu: false });
									}}>
									Select all
								</a>
								<a onClick={() => {
										this.phrasesList.selectNothing();
										this.setState({ showSelectMenu: false });
									}}>
									Select nothing
								</a>
								<a onClick={() => {
										this.props.app.saveUnselectedPhrases();
										this.setState({ showSelectMenu: false });
									}}>
									Save
								</a>
							</div>
						)}
						<button
								id="select-button"
								onClick={() => {
									this.setState({ showSelectMenu: true });
								}}>
							Select
						</button>
					</div>

					<button
						style={{ marginLeft: 5 }}
						onClick={() => {
								this.props.app.setState({ mode: 'settings' });
							}}>
						Settings
					</button>

					<button
							style={{ marginLeft: 5 }}
							onClick={() => {
								this.props.app.setState({ mode: 'help' });
						}}>
						?
					</button>

					<input
							type='checkbox'
							id="filter-phrases"
							style={ { marginLeft: 20 }}
							title="Filter phrases by words count"
							checked={this.state.filterPhrases}
							onChange={(e) => {
								CommonFunctions.saveSetting(
									'filterPhrases',
									Number(e.target.checked));
								this.setState(
									{ filterPhrases: e.target.checked });
						   }} />
					<label
							htmlFor="filter-phrases"
							style={{ marginLeft: 4 }}
							title="Filter phrases by words count">
						Filter phrases
					</label>

				</div>

				<div className="row content">
					<PhrasesList
						app={this.props.app}
						ref={(r) => { this.phrasesList = r; }} />
				</div>
			</div> );
	}
} // VoiceTrainerMainPanel



// WEBPACK FOOTER //
// ./src/VoiceTrainerMainPanel.js